// CIVICSUPPLY 2026-06-11 - Card variant dropdown wiring.
// Companion to snippets/civicsupply-card-variants.liquid (see its header doc).
// When a shopper picks a variant on a product card, this updates — within that
// card only — the buy-buttons form's hidden variant id (so Add to Cart adds the
// right variant), the displayed price, the card link, and the card image.
// Event delegation on document so it works for cards re-rendered by Horizon's
// filter/sort morphs without re-initialising anything.
(function () {
  // Horizon normally updates the form id when a variant picker changes. A
  // single-variant product has no picker, so initialise an empty form id from
  // its rendered quantity selector instead. This also leaves any deliberate
  // selection made by Horizon or a card dropdown untouched.
  function initialiseVariantId(productForm) {
    if (!productForm || !productForm.querySelector) return;

    var idInput = productForm.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (!idInput || idInput.value) return;

    var quantitySelector = productForm.querySelector('quantity-selector-component[data-variant-id]');
    var variantId = quantitySelector && quantitySelector.getAttribute('data-variant-id');
    if (variantId) idInput.value = variantId;
  }

  function initialiseVariantIds(scope) {
    if (!scope || !scope.querySelectorAll) return;

    var productForms = scope.querySelectorAll('product-form-component');
    for (var i = 0; i < productForms.length; i++) {
      initialiseVariantId(productForms[i]);
    }
  }

  function onChange(e) {
    var select = e.target;
    if (!select.classList || !select.classList.contains('civicsupply-card-variants__select')) return;

    var card = select.closest('product-card');
    if (!card) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;

    // 1) The hidden variant id input in the card's add-to-cart form.
    var idInput = card.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      idInput.value = option.value;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 2) Displayed price. Horizon renders the card price as span.price inside
    // .price__regular (plus a .price-item--sale twin in the price group).
    var price = option.getAttribute('data-price');
    if (price) {
      var priceEls = card.querySelectorAll('.price__regular .price, .price-item--sale');
      for (var i = 0; i < priceEls.length; i++) priceEls[i].textContent = price;
    }

    // 3) Card link follows the selected variant (so PDP opens pre-selected).
    var url = option.getAttribute('data-url');
    var link = card.querySelector('.product-card__link');
    if (url && link) link.setAttribute('href', url);

    // 4) Card image: swap to the variant's featured image when it has one.
    // Removing srcset/sizes makes the browser honour the plain src we set.
    var img = option.getAttribute('data-image');
    if (img) {
      var imgEl = card.querySelector('.product-card__content img');
      if (imgEl) {
        imgEl.removeAttribute('srcset');
        imgEl.removeAttribute('sizes');
        imgEl.setAttribute('src', img);
      }
    }

    // 5) Keep both purchase paths available while synchronizing the cart
    // button with the selected variant's availability.
    var available = option.getAttribute('data-available') === 'true';
    var cartBtn = card.querySelector('.civicsupply-atc-cart-btn');
    var quoteBtn = card.querySelector('.civicsupply-atc-quote-btn');
    if (cartBtn) {
      var addButton = cartBtn.querySelector('button[name="add"]');
      var label = cartBtn.querySelector('.civicsupply-atc-label');
      if (addButton) addButton.disabled = !available;
      if (label) {
        label.textContent = available
          ? cartBtn.getAttribute('data-civicsupply-add-to-cart-label')
          : cartBtn.getAttribute('data-civicsupply-sold-out-label');
      }
    }
    if (quoteBtn) quoteBtn.hidden = false;
  }

  initialiseVariantIds(document);
  document.addEventListener('DOMContentLoaded', function () {
    initialiseVariantIds(document);
  });
  document.addEventListener('shopify:section:load', function (e) {
    initialiseVariantIds(e.target);
  });

  // Horizon can re-render product controls after the initial page load. Resolve
  // the id again in the capture phase so an empty form can never be submitted
  // when its quantity selector already identifies a purchasable variant.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

      var productForm = form.closest('product-form-component');
      initialiseVariantId(productForm);
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (e) {
      var target = e.target;
      var addButton = target && target.closest && target.closest('button[name="add"]');
      if (addButton) initialiseVariantId(addButton.closest('product-form-component'));
    },
    true
  );

  document.addEventListener('change', onChange);

  // Stop the card's full-card link overlay from hijacking interaction with the
  // select (clicking a <select> must open the dropdown, not navigate).
  ['click', 'mousedown'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.target.closest && e.target.closest('.civicsupply-card-variants')) {
        e.stopPropagation();
      }
    });
  });
})();
